import { Skeleton } from '@nesso/ui/primitives/skeleton';

import { TableRowSkeleton } from '@/shared/ui/table/table-row-skeleton';

export function PastSessionsTableSkeleton({ rows = 5 }: { rows?: number }) {
    return (
        <div className="flex-1 overflow-auto min-h-0 flex flex-col px-8 sm:px-0">
            <div className="flex items-center gap-2 mt-6 mb-2">
                <Skeleton className="w-[160px] h-6" />
                <Skeleton className="w-6 h-6 rounded-full" />
            </div>
            {Array.from({ length: rows }).map((_, idx) => (
                <TableRowSkeleton key={idx} />
            ))}
        </div>
    );
}
